import { Reducer } from "redux";

import { DisciplineTemplateNotesResponse, NotesTemplateTypeResponse } from "../models/Api/Notes";
import { GetNotesTemplateTypeDispatchTypes } from "../models/DispatchTypes/Notes";
import { GetNotesTemplateTypeActionDispatchTypes } from "../constants/Notes";

export const initialState: NotesTemplateTypeResponse = {
    loading: false,
    response: [],
};

const NotesTemplateTypeReducer: Reducer<
    DisciplineTemplateNotesResponse,
    GetNotesTemplateTypeDispatchTypes
> = (state = initialState, action) => {
    switch (action.type) {
        case GetNotesTemplateTypeActionDispatchTypes.GET_NOTES_TEMPLATE_TYPE_INVOKE: {
            return {
                ...state,
                loading: true,
            };
        }
        case GetNotesTemplateTypeActionDispatchTypes.GET_NOTES_TEMPLATE_TYPE_SUCCESS: {
            return {
                ...state,
                response: action.response,
                loading: false,
            };
        }
    }
    return state;
};

export default NotesTemplateTypeReducer;
